import React from 'react';
import axios from 'helpers/axios';

import { UserLayout } from 'ui/components/layouts';
import { Title, Container, Form, Label, Select, TextArea, Button } from 'ui/components/styled';
import { useToasts, useLayout } from 'hooks';

export const Feedback = () => {
  const initialState = {
    type: '',
    comment: '',
  };
  const [state, setState] = React.useState(initialState);
  const { setLayoutLoading } = useLayout();
  const { errorToast, successToast } = useToasts();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((state) => ({ ...state, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLayoutLoading(true);
      const response = await axios.post('/feedback', {
        ...state,
        type: state.type.value,
      });
      if (response.status === 201) {
        successToast('Thanks for giving us your feedback!');
        setState(initialState);
      }
    } catch (error) {
      errorToast({ error, default: 'Error: Feedback submit.' });
    }
    setLayoutLoading(false);
  };

  return (
    <UserLayout>
      <Title variant="dark" mx="m" mb="l">
        Feedback
      </Title>
      <Title variant="grey" fontSize="25px" fontWeight="bold" mx="m" my="l">
        What type of feedback do you have?
      </Title>
      <Container width="480px" height="auto" px="m">
        <Form onSubmit={handleSubmit}>
          <Container mb="l">
            <Label htmlFor="type" mb="xs">
              Type
            </Label>
            <Select
              id="type"
              testId="type"
              placeholder="Please select a type."
              variant="minimal"
              options={[
                { label: 'Bug', value: 'Bug' },
                { label: 'Feature', value: 'Feature' },
                { label: 'Other', value: 'Other' },
              ]}
              value={state.type}
              onChange={(value) =>
                handleChange({
                  target: {
                    name: 'type',
                    value,
                  },
                })
              }
              required
            />
          </Container>
          <Container mb="l">
            <Label htmlFor="comment" mb="xs">
              Comment
            </Label>
            <TextArea
              id="comment"
              name="comment"
              placeholder="We'd love to hear from you!"
              variant="minimal"
              value={state.comment}
              onChange={handleChange}
              resize="vertical"
              rows={8}
              required
            />
          </Container>
          <Button type="submit">Send</Button>
        </Form>
      </Container>
    </UserLayout>
  );
};
